export default __webpack_public_path__ + "static/media/fact_sheet38.85652304.png";